// extracted by mini-css-extract-plugin
export default {"food_listin_page_container":"Food-listing-and-adding_food_listin_page_container__Zd2of","food_form_container":"Food-listing-and-adding_food_form_container__x3kWH"};